export enum MapIcons {
  VA = 'VehicleAccident',
  BDV = 'BrokenDownVehicle',
  CS = 'ConstructionSite',
  TL = 'TractionLoss',
  LV = 'LowVisibility',
  HR = 'HeavyRain',
  HS = 'HeavySnow',
  SW = 'StrongWind',
  PR = 'PoorRoad',
  WWD = 'WrongWayDriver',
  IOR = 'ItemOnRoad',
  AL = 'AmberLightVehicle',
  BL = 'BlueLightVehicle',
  SV = 'StoppedVehicle',
  TJT = 'TrafficJamTail',
  TVA = 'TestVehicleAccident',
  TBDV = 'TestBrokenDownVehicle',
  TCS = 'TestConstructionSite',
  TTL = 'TestTractionLoss',
  TLV = 'TestLowVisibility',
  THR = 'TestHeavyRain',
  THS = 'TestHeavySnow',
  TSW = 'TestStrongWind',
  TPR = 'TestPoorRoad',
  TWWD = 'TestWrongWayDriver',
  TIOR = 'TestItemOnRoad',
  TAL = 'TestAmberLightVehicle',
  TBL = 'TestBlueLightVehicle',
  TSV = 'TestStoppedVehicle',
  TTJT = 'TestTrafficJamTail',
  WC = 'Webcams',
}
